import './langTabs.scss';
import React from 'react';
import PropTypes from 'prop-types';
import { TabsBase } from 'library';

import US from 'assets/images/flags/US.svg';
import ES from 'assets/images/flags/ES.svg';
import VN from 'assets/images/flags/VN.svg';

const langs = [
    {
        key: 'en',
        title: 'English',
        icon: US
    },
    {
        key: 'es',
        title: 'Español',
        icon: ES
    },
    {
        key: 'vn',
        title: 'Tiếng Việt',
        icon: VN
    },
];

const LangTabs = ({ children, className }) => (
    <TabsBase className={`${className} lang-tabs`}>
        {langs.map(({ key, title, icon }) => {
            const tab = (
                <>
                    <img alt={key} src={icon} />
                    {title}
                </>
            );
            return (
                <TabsBase.TabPane
                    tab={tab}
                    key={key}
                >
                    {children(key)}
                </TabsBase.TabPane>
            );
        })}
    </TabsBase>
);
  
LangTabs.propTypes = {
    children: PropTypes.any.isRequired,
    className: PropTypes.string
};

export { LangTabs };
